import React, { useState } from "react";

export const CollapsePanel = ({
  header,
  extra,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="collapse__item">
      <div className="collapse__header" onClick={() => setOpen((v) => !v)}>
        <span
          className={`collapse__arrow${open ? " collapse__arrow--open" : ""}`}
        >
          &#9654;
        </span>
        <span style={{ flex: 1, marginLeft: 8 }}>{header}</span>
        {extra && <span className="collapse__extra">{extra}</span>}
      </div>
      {open && <div className="collapse__body">{children}</div>}
    </div>
  );
};

const Collapse = ({ children }) => {
  return <div className="collapse">{children}</div>;
};

export default Collapse;
